<template>
  <div class="meal" :key="restaurant.id">
    <div class="rounded-sm grid gap-2">
      <RestaurantMeal v-for="meal in meals" 
        :key="meal.id"
        :restaurant="restaurant" 
        :meal="meal" />
    </div>
  </div>
</template>
<script setup>
const route = useRoute()
const dayjs = useDayjs()
const fat = useFatStore()

const props = defineProps({
  restaurant: {
    type: Object,
    default: () => {}
  }
})

// Get meal ID's from route 
const mealIds = computed(() => route.query?.mealIds?.split(','))

// Get restaurant meals
const meals = computed(() => props.restaurant?.meals
  ?.filter(meal => meal?.type !== 8)
  ?.filter(meal => mealIds.value ? mealIds.value.includes(meal.id.toString()) : true)
  ?.filter(meal => meal?.name)
  ?.filter(meal => !meal?.startDate || dayjs(meal?.startDate).diff(dayjs(), 'days') < 42)
  ?.slice(0, 15))
</script>

<style lang="scss" scoped>
.meal {
  @apply grid gap-4 relative;
}

.date {
  @apply flex items-center justify-between -mx-1;

  &__center {
    @apply w-16 text-center relative;
  }

  &__button {
    @apply transition-all text-xl p-1 -my-1;

    &:disabled {
      @apply opacity-20;
    }
  }
}

.amount {
  @apply flex items-center justify-between;
  
  &__option {
    @apply flex justify-center;
  }
  
  &__pill {
    @apply font-bold cursor-pointer;
    @apply w-7 h-7 sm:w-8 sm:h-8 rounded-full;
    @apply flex items-center justify-center transition-all;

    &.selected {
      @apply bg-coral text-white;
      @apply pointer-events-none cursor-default;
    }

    @screen md {
      &:hover {
        @apply bg-mist;
      }
    }
  }
}
</style>